import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { api } from '@services/apiClient'

interface IExceptionEventTypes {
  code: string
  description: string
  isActive: boolean
  id: number
}

export const useFindExceptionEventTypes = () => {
  const { isMockEnvironment } = useMockEnvironment()

  async function fetchPermits() {
    if (!isMockEnvironment) {
      const { data } =
        await api.get<IExceptionEventTypes[]>(`/exceptionEventTypes`)

      return data
    }
  }

  return useQuery({
    queryKey: ['EXCEPTION_EVENT_TYPES'],
    queryFn: fetchPermits,
  })
}
